'use strict';

var Json = require("@glennsl/bs-json/lib/js/src/Json.js");
var Curry = require("rescript/lib/js/curry.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.js");
var Json_encode = require("@glennsl/bs-json/lib/js/src/Json_encode.js");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");
var Url$PvpcontrollerWeb = require("./Url.js");
var Request$PvpcontrollerWeb = require("./Request.js");
var UpdateResponse$PvpcontrollerWeb = require("./UpdateResponse.js");

var BadChange = /* @__PURE__ */Caml_exceptions.create("EditModeService-PvpcontrollerWeb.BadChange");

function optionToDefault(opt, encoder, $$default) {
  if (opt !== undefined) {
    return Curry._1(encoder, Caml_option.valFromOption(opt));
  } else {
    return $$default;
  }
}

function rawWeaponChange(name, weaponChange) {
  switch (weaponChange.TAG | 0) {
    case /* Damage */0 :
        var match = weaponChange._0;
        return {
                hd: [
                  "Name",
                  name
                ],
                tl: {
                  hd: [
                    "objectType",
                    "weapon"
                  ],
                  tl: {
                    hd: [
                      "changeType",
                      "damage"
                    ],
                    tl: {
                      hd: [
                        "oldValue",
                        match.old
                      ],
                      tl: {
                        hd: [
                          "newValue",
                          match.new
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
    case /* Velocity */1 :
        var match$1 = weaponChange._0;
        return {
                hd: [
                  "Name",
                  name
                ],
                tl: {
                  hd: [
                    "objectType",
                    "weapon"
                  ],
                  tl: {
                    hd: [
                      "changeType",
                      "velocity"
                    ],
                    tl: {
                      hd: [
                        "oldValue",
                        match$1.old
                      ],
                      tl: {
                        hd: [
                          "newValue",
                          match$1.new
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
    case /* MaxDamage */2 :
        var match$2 = weaponChange._0;
        return {
                hd: [
                  "Name",
                  name
                ],
                tl: {
                  hd: [
                    "objectType",
                    "weapon"
                  ],
                  tl: {
                    hd: [
                      "changeType",
                      "maxDamage"
                    ],
                    tl: {
                      hd: [
                        "oldValue",
                        optionToDefault(match$2.old, (function (prim) {
                                return prim;
                              }), -1)
                      ],
                      tl: {
                        hd: [
                          "newValue",
                          optionToDefault(match$2.new, (function (prim) {
                                  return prim;
                                }), -1)
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
    case /* MinDamage */3 :
        var match$3 = weaponChange._0;
        return {
                hd: [
                  "Name",
                  name
                ],
                tl: {
                  hd: [
                    "objectType",
                    "weapon"
                  ],
                  tl: {
                    hd: [
                      "changeType",
                      "minDamage"
                    ],
                    tl: {
                      hd: [
                        "oldValue",
                        optionToDefault(match$3.old, (function (prim) {
                                return prim;
                              }), -1)
                      ],
                      tl: {
                        hd: [
                          "newValue",
                          optionToDefault(match$3.new, (function (prim) {
                                  return prim;
                                }), -1)
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
    case /* Banned */4 :
        var match$4 = weaponChange._0;
        return {
                hd: [
                  "Name",
                  name
                ],
                tl: {
                  hd: [
                    "objectType",
                    "weapon"
                  ],
                  tl: {
                    hd: [
                      "changeType",
                      "banned"
                    ],
                    tl: {
                      hd: [
                        "oldValue",
                        match$4.old
                      ],
                      tl: {
                        hd: [
                          "newValue",
                          match$4.new
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
    
  }
}

function rawProjectileChange(name, projectileChange) {
  switch (projectileChange.TAG | 0) {
    case /* DamageRatio */0 :
        var match = projectileChange._0;
        return {
                hd: [
                  "Name",
                  name
                ],
                tl: {
                  hd: [
                    "objectType",
                    "projectile"
                  ],
                  tl: {
                    hd: [
                      "changeType",
                      "damageRatio"
                    ],
                    tl: {
                      hd: [
                        "oldValue",
                        match.old
                      ],
                      tl: {
                        hd: [
                          "newValue",
                          match.new
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
    case /* VelocityRatio */1 :
        var match$1 = projectileChange._0;
        return {
                hd: [
                  "Name",
                  name
                ],
                tl: {
                  hd: [
                    "objectType",
                    "projectile"
                  ],
                  tl: {
                    hd: [
                      "changeType",
                      "velocityRatio"
                    ],
                    tl: {
                      hd: [
                        "oldValue",
                        match$1.old
                      ],
                      tl: {
                        hd: [
                          "newValue",
                          match$1.new
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
    case /* Banned */2 :
        var match$2 = projectileChange._0;
        return {
                hd: [
                  "Name",
                  name
                ],
                tl: {
                  hd: [
                    "objectType",
                    "projectile"
                  ],
                  tl: {
                    hd: [
                      "changeType",
                      "banned"
                    ],
                    tl: {
                      hd: [
                        "oldValue",
                        match$2.old
                      ],
                      tl: {
                        hd: [
                          "newValue",
                          match$2.new
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
    
  }
}

function rawArmorPieceChange(name, armorPieceChange) {
  switch (armorPieceChange.TAG | 0) {
    case /* Defense */0 :
        var match = armorPieceChange._0;
        return {
                hd: [
                  "Name",
                  name
                ],
                tl: {
                  hd: [
                    "objectType",
                    "armorPiece"
                  ],
                  tl: {
                    hd: [
                      "changeType",
                      "defense"
                    ],
                    tl: {
                      hd: [
                        "oldValue",
                        match.old
                      ],
                      tl: {
                        hd: [
                          "newValue",
                          match.new
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
    case /* MeleeDamagePercentage */1 :
        var match$1 = armorPieceChange._0;
        return {
                hd: [
                  "Name",
                  name
                ],
                tl: {
                  hd: [
                    "objectType",
                    "armorPiece"
                  ],
                  tl: {
                    hd: [
                      "changeType",
                      "meleeDamagePercentage"
                    ],
                    tl: {
                      hd: [
                        "oldValue",
                        match$1.old
                      ],
                      tl: {
                        hd: [
                          "newValue",
                          match$1.new
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
    case /* MagicDamagePercentage */2 :
        var match$2 = armorPieceChange._0;
        return {
                hd: [
                  "Name",
                  name
                ],
                tl: {
                  hd: [
                    "objectType",
                    "armorPiece"
                  ],
                  tl: {
                    hd: [
                      "changeType",
                      "magicDamagePercentage"
                    ],
                    tl: {
                      hd: [
                        "oldValue",
                        match$2.old
                      ],
                      tl: {
                        hd: [
                          "newValue",
                          match$2.new
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
    case /* RangedDamagePercentage */3 :
        var match$3 = armorPieceChange._0;
        return {
                hd: [
                  "Name",
                  name
                ],
                tl: {
                  hd: [
                    "objectType",
                    "armorPiece"
                  ],
                  tl: {
                    hd: [
                      "changeType",
                      "rangedDamagePercentage"
                    ],
                    tl: {
                      hd: [
                        "oldValue",
                        match$3.old
                      ],
                      tl: {
                        hd: [
                          "newValue",
                          match$3.new
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
    case /* MinionDamagePercentage */4 :
        var match$4 = armorPieceChange._0;
        return {
                hd: [
                  "Name",
                  name
                ],
                tl: {
                  hd: [
                    "objectType",
                    "armorPiece"
                  ],
                  tl: {
                    hd: [
                      "changeType",
                      "minionDamagePercentage"
                    ],
                    tl: {
                      hd: [
                        "oldValue",
                        match$4.old
                      ],
                      tl: {
                        hd: [
                          "newValue",
                          match$4.new
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              };
    
  }
}

function rawSettingsChange(settingsChange) {
  switch (settingsChange.TAG | 0) {
    case /* BannedEquipment */0 :
        var match = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "bannedEquipment"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* DamageDisableSeconds */1 :
        var match$1 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "damageDisableSeconds"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$1.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$1.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* BanTeleportItems */2 :
        var match$2 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "banTeleportItems"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$2.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$2.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* BanPrefixedArmor */3 :
        var match$3 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "banPrefixedArmor"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$3.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$3.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* PotionHealAmount */4 :
        var match$4 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "potionHealAmount"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$4.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$4.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* PotionHealCooldown */5 :
        var match$5 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "potionHealCooldown"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$5.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$5.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* PreventImpossibleEquipment */6 :
        var match$6 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "preventImpossibleEquipment"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$6.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$6.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* BeetleArmorStage1 */7 :
        var match$7 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "beetleArmorStage1"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$7.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$7.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* BeetleArmorStage2 */8 :
        var match$8 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "beetleArmorStage2"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$8.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$8.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* BeetleArmorStage3 */9 :
        var match$9 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "beetleArmorStage3"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$9.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$9.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* SolarArmorStage1 */10 :
        var match$10 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "solarArmorStage1"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$10.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$10.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* SolarArmorStage2 */11 :
        var match$11 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "solarArmorStage2"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$11.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$11.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* SolarArmorStage3 */12 :
        var match$12 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "solarArmorStage3"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$12.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$12.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* ForceMaxHealth */13 :
        var match$13 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "forceMaxHealth"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$13.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$13.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* NeverRain */14 :
        var match$14 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "neverRain"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$14.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$14.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* AllowHookOfDissonance */15 :
        var match$15 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "allowHookOfDissonance"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$15.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$15.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* CorrectPositionDesync */16 :
        var match$16 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "correctPositionDesync"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$16.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$16.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* CorrectionMinDistance */17 :
        var match$17 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "correctionMinDistance"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$17.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$17.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* DefenseMultiplier */18 :
        var match$18 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "defenseMultiplier"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$18.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$18.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* DamageVariation */19 :
        var match$19 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "damageVariation"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$19.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$19.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* Time */20 :
        var match$20 = settingsChange._0;
        return {
                hd: [
                  "objectType",
                  "settings"
                ],
                tl: {
                  hd: [
                    "changeType",
                    "time"
                  ],
                  tl: {
                    hd: [
                      "oldValue",
                      match$20.old
                    ],
                    tl: {
                      hd: [
                        "newValue",
                        match$20.new
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              };
    
  }
}

function rawChange(param) {
  var info = param.info;
  var properties;
  switch (info.TAG | 0) {
    case /* Weapon */0 :
        properties = rawWeaponChange(info._0, info._1);
        break;
    case /* Projectile */1 :
        properties = rawProjectileChange(info._0, info._1);
        break;
    case /* ArmorPiece */2 :
        properties = rawArmorPieceChange(info._0, info._1);
        break;
    case /* Settings */3 :
        properties = rawSettingsChange(info._0);
        break;
    
  }
  return Json_encode.object_({
              hd: [
                "NetID",
                param.netId
              ],
              tl: properties
            });
}

function editModeResponse(json) {
  return {
          TAG: /* Ok */0,
          _0: {
            status: Json_decode.field("status", Json_decode.$$int, json),
            enabled: Json_decode.field("enabled", Json_decode.bool, json)
          }
        };
}

function change(json) {
  var object = Json_decode.field("objectType", Json_decode.string, json);
  var changeType = Json_decode.field("changeType", Json_decode.string, json);
  var name;
  try {
    name = Json_decode.field("Name", Json_decode.string, json);
  }
  catch (_e){
    name = "";
  }
  var avatar = Json_decode.field("avatar", Json_decode.string, json);
  var username = Json_decode.field("username", Json_decode.string, json);
  var timestamp = Json_decode.field("timestamp", Json_decode.$$float, json);
  var unconfirmed;
  try {
    unconfirmed = Json_decode.field("unconfirmed", Json_decode.bool, json);
  }
  catch (exn){
    unconfirmed = false;
  }
  var netId = Json_decode.field("NetID", Json_decode.$$int, json);
  var info;
  switch (object) {
    case "armorPiece" :
        switch (changeType) {
          case "defense" :
              info = {
                TAG: /* ArmorPiece */2,
                _0: name,
                _1: {
                  TAG: /* Defense */0,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "magicDamagePercentage" :
              info = {
                TAG: /* ArmorPiece */2,
                _0: name,
                _1: {
                  TAG: /* MagicDamagePercentage */2,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "meleeDamagePercentage" :
              info = {
                TAG: /* ArmorPiece */2,
                _0: name,
                _1: {
                  TAG: /* MeleeDamagePercentage */1,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "minionDamagePercentage" :
              info = {
                TAG: /* ArmorPiece */2,
                _0: name,
                _1: {
                  TAG: /* MinionDamagePercentage */4,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "rangedDamagePercentage" :
              info = {
                TAG: /* ArmorPiece */2,
                _0: name,
                _1: {
                  TAG: /* RangedDamagePercentage */3,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          default:
            throw {
                  RE_EXN_ID: BadChange,
                  Error: new Error()
                };
        }
        break;
    case "projectile" :
        switch (changeType) {
          case "banned" :
              info = {
                TAG: /* Projectile */1,
                _0: name,
                _1: {
                  TAG: /* Banned */2,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.bool, json),
                    new: Json_decode.field("newValue", Json_decode.bool, json)
                  }
                }
              };
              break;
          case "damageRatio" :
              info = {
                TAG: /* Projectile */1,
                _0: name,
                _1: {
                  TAG: /* DamageRatio */0,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$float, json),
                    new: Json_decode.field("newValue", Json_decode.$$float, json)
                  }
                }
              };
              break;
          case "velocityRatio" :
              info = {
                TAG: /* Projectile */1,
                _0: name,
                _1: {
                  TAG: /* VelocityRatio */1,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$float, json),
                    new: Json_decode.field("newValue", Json_decode.$$float, json)
                  }
                }
              };
              break;
          default:
            throw {
                  RE_EXN_ID: BadChange,
                  Error: new Error()
                };
        }
        break;
    case "settings" :
        switch (changeType) {
          case "allowHookOfDissonance" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* AllowHookOfDissonance */15,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.bool, json),
                    new: Json_decode.field("newValue", Json_decode.bool, json)
                  }
                }
              };
              break;
          case "banPrefixedArmor" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* BanPrefixedArmor */3,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.bool, json),
                    new: Json_decode.field("newValue", Json_decode.bool, json)
                  }
                }
              };
              break;
          case "banTeleportItems" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* BanTeleportItems */2,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.bool, json),
                    new: Json_decode.field("newValue", Json_decode.bool, json)
                  }
                }
              };
              break;
          case "bannedEquipment" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* BannedEquipment */0,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.bool, json),
                    new: Json_decode.field("newValue", Json_decode.bool, json)
                  }
                }
              };
              break;
          case "beetleArmorStage1" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* BeetleArmorStage1 */7,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "beetleArmorStage2" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* BeetleArmorStage2 */8,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "beetleArmorStage3" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* BeetleArmorStage3 */9,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "correctPositionDesync" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* CorrectPositionDesync */16,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.bool, json),
                    new: Json_decode.field("newValue", Json_decode.bool, json)
                  }
                }
              };
              break;
          case "correctionMinDistance" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* CorrectionMinDistance */17,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "damageDisableSeconds" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* DamageDisableSeconds */1,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "damageVariation" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* DamageVariation */19,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "defenseMultiplier" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* DefenseMultiplier */18,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "forceMaxHealth" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* ForceMaxHealth */13,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.bool, json),
                    new: Json_decode.field("newValue", Json_decode.bool, json)
                  }
                }
              };
              break;
          case "neverRain" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* NeverRain */14,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.bool, json),
                    new: Json_decode.field("newValue", Json_decode.bool, json)
                  }
                }
              };
              break;
          case "potionHealAmount" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* PotionHealAmount */4,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "potionHealCooldown" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* PotionHealCooldown */5,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "preventImpossibleEquipment" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* PreventImpossibleEquipment */6,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.bool, json),
                    new: Json_decode.field("newValue", Json_decode.bool, json)
                  }
                }
              };
              break;
          case "solarArmorStage1" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* SolarArmorStage1 */10,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "solarArmorStage2" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* SolarArmorStage2 */11,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "solarArmorStage3" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* SolarArmorStage3 */12,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "time" :
              info = {
                TAG: /* Settings */3,
                _0: {
                  TAG: /* Time */20,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          default:
            throw {
                  RE_EXN_ID: BadChange,
                  Error: new Error()
                };
        }
        break;
    case "weapon" :
        switch (changeType) {
          case "banned" :
              info = {
                TAG: /* Weapon */0,
                _0: name,
                _1: {
                  TAG: /* Banned */4,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.bool, json),
                    new: Json_decode.field("newValue", Json_decode.bool, json)
                  }
                }
              };
              break;
          case "damage" :
              info = {
                TAG: /* Weapon */0,
                _0: name,
                _1: {
                  TAG: /* Damage */0,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          case "maxDamage" :
              var oldRaw = Json_decode.field("oldValue", Json_decode.$$int, json);
              var newRaw = Json_decode.field("newValue", Json_decode.$$int, json);
              var old = oldRaw === -1 ? undefined : oldRaw;
              var $$new = newRaw === -1 ? undefined : newRaw;
              info = {
                TAG: /* Weapon */0,
                _0: name,
                _1: {
                  TAG: /* MaxDamage */2,
                  _0: {
                    old: old,
                    new: $$new
                  }
                }
              };
              break;
          case "minDamage" :
              var oldRaw$1 = Json_decode.field("oldValue", Json_decode.$$int, json);
              var newRaw$1 = Json_decode.field("newValue", Json_decode.$$int, json);
              var old$1 = oldRaw$1 === -1 ? undefined : oldRaw$1;
              var $$new$1 = newRaw$1 === -1 ? undefined : newRaw$1;
              info = {
                TAG: /* Weapon */0,
                _0: name,
                _1: {
                  TAG: /* MinDamage */3,
                  _0: {
                    old: old$1,
                    new: $$new$1
                  }
                }
              };
              break;
          case "velocity" :
              info = {
                TAG: /* Weapon */0,
                _0: name,
                _1: {
                  TAG: /* Velocity */1,
                  _0: {
                    old: Json_decode.field("oldValue", Json_decode.$$int, json),
                    new: Json_decode.field("newValue", Json_decode.$$int, json)
                  }
                }
              };
              break;
          default:
            throw {
                  RE_EXN_ID: BadChange,
                  Error: new Error()
                };
        }
        break;
    default:
      throw {
            RE_EXN_ID: BadChange,
            Error: new Error()
          };
  }
  return {
          changedBy: {
            username: username,
            avatar: avatar
          },
          timestamp: timestamp,
          unconfirmed: unconfirmed,
          netId: netId,
          info: info
        };
}

function changelogResponse(json) {
  return {
          status: Json_decode.field("status", Json_decode.$$int, json),
          changes: Json_decode.field("changes", (function (param) {
                  return Json_decode.array(change, param);
                }), json)
        };
}

function getEditModeState(cb) {
  return Request$PvpcontrollerWeb.getWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/editmode", editModeResponse, cb);
}

function setEditModeState(param, enabled, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/editmode", "enabled=" + (
              enabled ? "true" : "false"
            ) + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function getEditModeChangelog(param, cb) {
  var match = param.VAL;
  var sessionId = encodeURIComponent(String(match.id));
  var token = encodeURIComponent(match.token);
  return Request$PvpcontrollerWeb.getWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/editmode/changelog?sessionId=" + sessionId + "&token=" + token, (function (response) {
                return {
                        TAG: /* Ok */0,
                        _0: changelogResponse(response).changes
                      };
              }), cb);
}

function publishEditModeChangelog(param, changes, cb) {
  var match = param.VAL;
  var json = Json_encode.object_({
        hd: [
          "sessionId",
          match.id
        ],
        tl: {
          hd: [
            "token",
            match.token
          ],
          tl: {
            hd: [
              "changes",
              Json_encode.array(rawChange, changes)
            ],
            tl: /* [] */0
          }
        }
      });
  return Request$PvpcontrollerWeb.postWithContentTypeAndDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/editmode/publishchanges", Json.stringify(json), "application/json", UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function rollbackEditModeChangelog(param, changes, cb) {
  var match = param.VAL;
  var json = Json_encode.object_({
        hd: [
          "sessionId",
          match.id
        ],
        tl: {
          hd: [
            "token",
            match.token
          ],
          tl: {
            hd: [
              "changes",
              Json_encode.array(rawChange, changes)
            ],
            tl: /* [] */0
          }
        }
      });
  return Request$PvpcontrollerWeb.postWithContentTypeAndDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/editmode/rollbackchanges", Json.stringify(json), "application/json", UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function publishEditModeChange(param, changes, change, cb) {
  var match = param.VAL;
  var json = Json_encode.object_({
        hd: [
          "sessionId",
          match.id
        ],
        tl: {
          hd: [
            "token",
            match.token
          ],
          tl: {
            hd: [
              "changes",
              Json_encode.array(rawChange, changes)
            ],
            tl: {
              hd: [
                "change",
                rawChange(change)
              ],
              tl: /* [] */0
            }
          }
        }
      });
  return Request$PvpcontrollerWeb.postWithContentTypeAndDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/editmode/publishchange", Json.stringify(json), "application/json", UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function rollbackEditModeChange(param, changes, change, cb) {
  var match = param.VAL;
  var json = Json_encode.object_({
        hd: [
          "sessionId",
          match.id
        ],
        tl: {
          hd: [
            "token",
            match.token
          ],
          tl: {
            hd: [
              "changes",
              Json_encode.array(rawChange, changes)
            ],
            tl: {
              hd: [
                "change",
                rawChange(change)
              ],
              tl: /* [] */0
            }
          }
        }
      });
  return Request$PvpcontrollerWeb.postWithContentTypeAndDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/editmode/rollbackchange", Json.stringify(json), "application/json", UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

var Decode = {
  change: change
};

exports.Decode = Decode;
exports.getEditModeState = getEditModeState;
exports.setEditModeState = setEditModeState;
exports.getEditModeChangelog = getEditModeChangelog;
exports.publishEditModeChangelog = publishEditModeChangelog;
exports.rollbackEditModeChangelog = rollbackEditModeChangelog;
exports.publishEditModeChange = publishEditModeChange;
exports.rollbackEditModeChange = rollbackEditModeChange;
/* Url-PvpcontrollerWeb Not a pure module */
